<template>
    <div class="iconed-input">
        <input-field
            :min="min"
            :max="max"
            :type="type"
            :id="id"
            :placeholder="placeholder"
            :value="value"
            :name="name"
            :autocomplete="autocomplete"
            :required="isRequired"
            :disabled="isDisabled"
            :readonly="isReadonly"
            :accept="accept"
            @input="onInput"
            @focus="onFocus"
            @focusout="onFocusOut"
            @onEnter="onEnter"
        />
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            placeholder: {
                type: String,
                default: ''
            },
            autocomplete: {
                type: String,
                default: 'off'
            },
            name: String,
            isRequired: {
                type: Boolean,
                default: true
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            isReadonly: {
                type: Boolean,
                default: false
            },
            id: String,
            value: String,
            type: {
                type: String,
                default: 'text'
            },
            accept: String,
            min: {
                type: [Number, String]
            },
            max: {
                type: [Number, String]
            }
        },
        methods: {
            onInput(value) {
                this.$emit('input', value);
            },
            onFocus(value) {
                this.$emit('focus', value);
            },
            onFocusOut(value) {
                this.$emit('focusout', value);
            },
            onEnter(e) {
                this.$emit('onEnter', e);
            },
        },
    }
</script>

<style scoped lang="scss">
    .iconed-input {
        position: relative;

        > input {
            padding-right: 30px;
        }

        input[readonly="readonly"] {
            cursor: not-allowed;
            background-color: #e3e2e2;
        }

        img, i, ion-icon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
        }

        img {
            right: 5px;
            width: 20px;
        }

        > .warning, > .success {
            right: 4px;
        }
    }
</style>
